import React from 'react';
import { FaTimes, FaHeart, FaShoppingCart, FaStar, FaStarHalfAlt, FaRegStar, FaEnvelope } from 'react-icons/fa';
import { useAppContext } from '../context/AppContext';

const QuickViewModal = () => {
  const { 
    quickViewProduct, 
    closeQuickView,
    toggleWishlist,
    wishlist,
    addToCart,
    inquiryItems,
  } = useAppContext();

  if (!quickViewProduct) return null;

  const { 
    id = '',
    name = 'Product',
    price = 0,
    image = 'https://via.placeholder.com/500',
    rating = 0,
    isNew = false
  } = quickViewProduct;

  const renderStars = () => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    for (let i = 0; i < fullStars; i++) {
      stars.push(<FaStar key={`full-${i}`} />);
    }
    if (hasHalfStar) {
      stars.push(<FaStarHalfAlt key="half" />);
    }
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<FaRegStar key={`empty-${i}`} />);
    }
    return stars;
  };

  const isInWishlist = wishlist.includes(id);

  return (
    <div className="modal show" onClick={(e) => e.target === e.currentTarget && closeQuickView()}>
      <div className="modal-content">
        <div className="modal-header">
          <h3>{name}</h3>
          <button className="close-modal" onClick={closeQuickView}>
            <FaTimes />
          </button>
        </div>
        <div className="modal-body">
          <div className="modal-product-images">
            <div className="modal-main-image">
              <img src={image} alt={name} />
            </div>
          </div>
          <div className="modal-product-info">
            <h2>{name}</h2>
            <div className="modal-price">${price.toFixed(2)}</div>
            <div className="modal-rating">
              {renderStars()}
              <span>({rating.toFixed(1)})</span>
            </div>
            <div className="modal-actions">
              <button 
                className={`btn btn-outline ${isInWishlist ? 'active' : ''}`}
                onClick={() => toggleWishlist(id)}
              >
                <FaHeart /> {isInWishlist ? 'In Wishlist' : 'Add to Wishlist'}
              </button>
              <button 
                className="btn" 
                onClick={() => {
                    inquiryItems(id);
                  closeQuickView();
                }}
              >
                <FaEnvelope /> Inquiry
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickViewModal;